import { Check } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { BottomAppBar } from '../../../../components/BottomAppBar';
import { PageHeader } from '../../../../components/PageHeader';
import { useSafeNavigation } from '../../../../hooks/useSafeNavigation';
import { PageContent, PageLayout } from '../../../../layout';
import { InvoiceManagementInvoiceFormType } from '../../../../modules/forms/invoice/types';
import { InvoiceManagementInvoiceFormModule } from '../../../../modules/invoice-management/InvoiceManagementInvoiceFormModule';
import { useConfirmInvoiceManagementInvoiceForm } from '../../../../modules/invoice-management/useConfirmInvoiceManagementInvoiceForm';
import { notify } from '../../../../utils/notification';

export const InvoiceManagementCreateInvoicePage = () => {
  const { t } = useTranslation('page-invoice-management');
  const { safeNavigate } = useSafeNavigation();

  const {
    onFormSubmit,
    state: { isReady, isLoading },
  } = useConfirmInvoiceManagementInvoiceForm({
    onSuccess: (id) => safeNavigate(`/invoice-management/invoices/${id}`),
    onError: () => {
      notify.negative({
        title: t('error.mutation.title'),
        message: t('error.mutation.text'),
      });
    },
    onValidationError: () => {
      notify.negative({
        title: t('error.validation.title'),
        message: t('error.validation.text'),
      });
    },
  });

  const handleFormSubmit = async (data: InvoiceManagementInvoiceFormType) => {
    try {
      onFormSubmit(data);
    } catch (e) {
      console.error(e);
      notify.negative({
        title: t('error.mutation.title'),
        message: t('error.mutation.text'),
      });
    }
  };

  return (
    <PageLayout>
      <PageHeader title={t('newInvoice')} backRouteTo={-1} />
      <PageContent>
        <InvoiceManagementInvoiceFormModule
          invoiceFormProps={{
            formId: 'invoice-form',
            onSubmit: handleFormSubmit,
            defaultValidated: false,
          }}
        />
      </PageContent>
      <BottomAppBar stackProps={{ justifyContent: 'flex-end' }}>
        <LoadingButton
          loading={isLoading}
          disabled={!isReady}
          type={'submit'}
          form={'invoice-form'}
          variant={'contained'}
          size={'large'}
          startIcon={<Check />}
        >
          {t('action.confirm')}
        </LoadingButton>
      </BottomAppBar>
    </PageLayout>
  );
};
